import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { errorManagerActions } from "@/business/shared/commons/rest/errorManagerActions";
import { loginWebUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { LoginRequest, UserAuth, LoginActions } from "../../domain/login";

export const loginService = {
  async execute(createLoginRequest: LoginRequest): Promise<UserAuth> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(loginWebUrl);
    const headers = {
      "Content-Type": "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "POST",
      JSON.stringify(createLoginRequest),
      headers
    );

    if (!response.isSuccess) {
      throw errorManagerActions().transformDaccach(response.content);
    }

    return LoginActions().deserialize(
      createLoginRequest.username,
      response.content
    );
  },
};
